import { IPassportGroup, IPassportSchema } from '@/pages/MDM/mdm.types.ts'
import usePassportSchema from '@/pages/MDM/hooks/usePassprotSchema.ts'
import { useMemo } from 'react'

const usePassportGroup = (id: IPassportGroup['id'], passportId: IPassportSchema['id']) => {
  const passport = usePassportSchema(passportId)

  return useMemo(() => {
    return passport.groups.find((g) => g.id === id)
  }, [passport.groups, id])
}

export default usePassportGroup
